import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const PortfolioBenchmarkPage = lazy(() => import('./PortfolioBenchmarkPage'));

const path = 'reports/benchmark';
const PortfolioBenchmarkRoute: FuseRouteItemType = {
	path: path,
	element: <PortfolioBenchmarkPage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Portfolio Benchmark',
					helpName: 'Benchmark',
					showTitle: false,
					showCrumbs: false
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default PortfolioBenchmarkRoute;
